import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreServiceService } from '../core/core-service.service';
import { MasterTimeBaseContractProfile } from '../Models/master-time-base-contract-profile';
import { Status } from '../Models/status';

@Injectable({
  providedIn: 'root'
})
export class ProductProfileService {
  private BaseApiPath:string;
  constructor(private http:HttpClient,private coreService:CoreServiceService) { 

    this.BaseApiPath=this.coreService.appSettings && this.coreService.appSettings.ParkBaseApiPath;

  }
  public getProductProfiles():Observable<MasterTimeBaseContractProfile[]>{
    const ApiUrl=this.BaseApiPath+'productprofile/getProductProfiles';
      return this.http.get<MasterTimeBaseContractProfile[]>(ApiUrl);
  }
  public InsertUpdateProductProfiles(masterTimeBasedContractProfile:MasterTimeBaseContractProfile):Observable<Status<string>>{
    const ApiUrl=this.BaseApiPath+'productprofile/insertUpdateProductProfile';
      return this.http.post<Status<string>>(ApiUrl,masterTimeBasedContractProfile);
  }
  public getProductProfile(masterTimeBasedContractProfile:MasterTimeBaseContractProfile):Observable<MasterTimeBaseContractProfile>{
    const ApiUrl=this.BaseApiPath+'productprofile/getProductProfile';
      return this.http.post<MasterTimeBaseContractProfile>(ApiUrl,masterTimeBasedContractProfile);
  }
  public getSearchedProductProfile(search:string):Observable<MasterTimeBaseContractProfile[]>{
    const ApiUrl=this.BaseApiPath+'productprofile/searchProductProfile';
      return this.http.post<MasterTimeBaseContractProfile[]>(ApiUrl,{Status_msg:search});
  }
}
